import _ from "lodash";
import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

const SimplePopup = (props) => {
    const {
        confirmModal,
        setConfirmModal,
        showModalMsg,
        isRightIcon,
        isMobile
    } = props;

   
;

    return (
        <Modal
            show={confirmModal}
            onHide={() =>{setConfirmModal(false)}}
            size="500px"
            aria-labelledby="contained-modal-title-vcenter"
            className="alert-modal"
            centered={isMobile ? false : true}
        >
            {/* <Modal.Header closeButton className="modal-header">
            <Modal.Title>Favourite Delete Alert</Modal.Title>
        </Modal.Header> */}
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body className="invalidemailshowfp">
            <div className="d-flex flex-column align-items-center gap-2">
            {isRightIcon ? (
                <>
                    {" "}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 18 18"
                    >
                        <g
                            id="Group_5760"
                            data-name="Group 5760"
                            transform="translate(0.498 0.498)"
                        >
                            <circle
                                id="Ellipse_222"
                                data-name="Ellipse 222"
                                cx="9"
                                cy="9"
                                r="9"
                                transform="translate(-0.498 -0.498)"
                                fill="#a9c23c"
                            />
                            <path
                                id="Icon_material-done"
                                data-name="Icon material-done"
                                d="M9.712,16.558,7.79,14.88l-.9.9L9.712,18.35l6.425-6.657-.9-.9Z"
                                transform="translate(-3.013 -6.071)"
                                fill="#fff"
                                stroke="#fff"
                                strokeWidth="2"
                            />
                        </g>
                    </svg>
                </>
            ) : (
                <>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22" fill="none">
                        <path d="M23.7526 18.5469L13.7682 1.48438C13.3463 0.828125 12.69 0.5 12.0338 0.5C11.3307 0.5 10.6744 0.828125 10.2526 1.48438L0.221349 18.5469C-0.481776 19.8594 0.455729 21.5 2.0026 21.5H22.0182C23.5651 21.5 24.5026 19.8594 23.7526 18.5469ZM2.47135 19.25L11.9869 2.98438L21.5494 19.25H2.47135ZM12.0338 14.8438C11.19 14.8438 10.5338 15.5 10.5338 16.2969C10.5338 17.0938 11.19 17.75 12.0338 17.75C12.8307 17.75 13.4869 17.0938 13.4869 16.2969C13.4869 15.5 12.8307 14.8438 12.0338 14.8438ZM10.9088 7.625V12.125C10.9088 12.7812 11.3776 13.25 12.0338 13.25C12.6432 13.25 13.1588 12.7812 13.1588 12.125V7.625C13.1588 7.01562 12.6432 6.5 12.0338 6.5C11.3776 6.5 10.9088 7.01562 10.9088 7.625Z" fill="#2d2d2d"/>
                    </svg>
                </>
            )}
            {showModalMsg}
        </div>
            </Modal.Body>
                <Modal.Footer className="justify-content-center">
                        <Button
                            variant="primary"
                            className="confirm"
                            onClick={() => setConfirmModal(false)}
                        >
                            Ok
                        </Button>
                    
                </Modal.Footer>
        
        </Modal>
    );
};

export default SimplePopup;
